const SERVICE_SLUG_ALIASES: Record<string, string> = {
  web: 'development',
  mobile: 'development',
  'web-development': 'development',
  branding: 'design',
  seo: 'marketing',
  analytics: 'marketing',
}

const SUBSERVICE_SLUG_ALIASES: Record<string, string> = {
  // landing: 'promo-landing',
}

export function normalizeServiceSlug(slug: string): string {
  return SERVICE_SLUG_ALIASES[slug] || slug
}

export function normalizeSubServiceSlug(slug: string): string {
  return SUBSERVICE_SLUG_ALIASES[slug] || slug
}

export function normalizeDirectionTab(tab: string | null | undefined): string | null {
  if (!tab) return null
  return normalizeServiceSlug(tab)
}
